import React from 'react';
import { Link } from 'react-router-dom';
import './index.css';
import Hero from '../../components/Hero';
import Stats from '../../components/Stats';
import Expertise from '../../components/Expertise';
import MarketKnowledge from '../../components/MarketKnowledge';
import GatewaySection from '../../components/GatewaySection';
import ContactSection from '../../components/ContactSection';

function HomePage() {
    return (
    <>
      <div className='hero-background'>
      <div className="hero-section">
        <Hero />
        {/* <Stats /> */}
      </div>
      </div>
      <Expertise />
      <MarketKnowledge />
      <GatewaySection />
      <ContactSection />
    </>
    );
}

export default HomePage;